const APPCONFIG = {
    ENDPOINTS: {
        SECURITYURL: process.env.REACT_APP_SECURITYURL,
        PRODUCERURL: process.env.REACT_APP_PRODUCERURL,
    },
    FOOTER: {
        ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
        VERSION: 'V 2.5.0',
        PORTAL: 'Portal de Productores',
        BUTTON_TEXT: 'Soporte técnico',
    },
    URLS: {
        CANALESLINK: process.env.REACT_APP_CANALESLINK,
        EBROKERLINK: process.env.REACT_APP_EBROKERLINK,
    },
    ENABLESCHEDULER: process.env.REACT_APP_ENABLESCHEDULER
}
export { APPCONFIG };